import { QUAL_REVIEWS_HELPFUL } from '../experimentsEnum';
import { inAbTest } from '..';

export default (abTests) => inAbTest(abTests, QUAL_REVIEWS_HELPFUL);
